<sc-flex fitHeight stretchContent vertical>
  <sc-flex stretchContent>
    <sc-content-spacer grow></sc-content-spacer>
    <sc-button (click)="copyLogToClipboard()" dictionaryKey="tmc.personalvisit.dialog.protocol.action.copy-to-clipboard">
      <sc-icon iconClass="fa-copy"></sc-icon>
    </sc-button>
  </sc-flex>
  <sc-flex-fitting-content vertical>
    <sc-scroll-pane>
      @if (visit) {
        <table class="table" style="border-spacing: 16px;">
          @for (entry of logEntries; track entry) {
            <tr class="text-selection">
              <td class="text-selection" style="white-space: nowrap;">
                {{entry.timestamp}}
              </td>
              <td>
                {{entry.displayText}}
              </td>
            </tr>
          }
        </table>
      }
    </sc-scroll-pane>
  </sc-flex-fitting-content>
</sc-flex>
